module.exports = __webpack_public_path__ + "static/media/icon_group_builder_over.87cd6dc5.svg";